<template>
    <div id="Pbb">
        <div class="pt-3 row">
            <div class="text-center col-8 LoaSelector">
                <label for="loa-active" class="form-label text-right">
                    LOA Pairing: 
                </label>
                <label for="LoaActive" :class="['ActiveIndicator text-left', {'Inactive' : !LoaActive}]">{{isLoaActive}}
                    <input type="checkbox" id="LoaActive" name="LoaActive" v-model="LoaActive">
                    <span class="checkmark">
                        <span class='checkmark-inner'></span>
                    </span>
                </label>
            </div>
        </div>
        <div class="pt-3">
            <label for="input-sku" class="form-label">
            Enter SKU
            </label>
            <input ref='skuInput' type="text" v-model="sku" name='scannedSku' @keyup='findItem' @focus="sku=''" class="form-control" id="input-sku-to-pick">
        </div>
        <div class='row error-msg' v-if="scanError != ''">
            <div class='col-12 text-center'><span>{{scanError}}</span></div>
        </div>
        <div class="row ScannedProductInfo" v-if="(currentProduct.productSku) && (scanError == '')">
            <div class='col-12'>
                <div class="row mt-3 mb-3">
                    <div class="col-3">
                        <img :src="productImage" class="img-fluid">
                    </div>
                    <div class="col-9 align-self-center">
                        <div class="form-group">
                            <div class="form-label">
                                SKU
                            </div>
                            <div>
                                {{ productSku }}
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="form-label">
                                Description
                            </div>
                            <div>
                                {{ productDescription }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row row-orderInfo' v-if="!orderToTransfer">
                    <div class='col-12'>
                        <div class='row divider'>
                            <div class='col-12'>
                                <h3>Customer Name</h3>
                            </div>
                        </div>
                        <div class='row value'>
                            <div class="col-12 mb-1">
                                {{ scannedOrder.customer }}
                            </div>
                        </div>
                        <div class='row divider'>
                            <div class='col-12'>
                                <h3>SO#</h3>
                            </div>
                        </div>
                        <div class='row value'>
                            <div class="col-12 mb-1">
                            <a :href='orderLink' target='_blank'>  {{ firstOrder.order_number }} </a>
                            </div>
                        </div>
                        <div class='row divider'>
                            <div class='col-12'>
                                <h3>PO#</h3>
                            </div>
                        </div>
                        <div class='row value'>
                            <div class="col-12 mb-1">
                                {{ firstOrder.po_number }}
                            </div>
                        </div>
                        <div class='row divider'>
                            <div class='col-12'>
                                <h3>Offer</h3>
                            </div>
                        </div>
                        <div class='row value'>
                            <div class='col-12 mb-1'>
                                <strong>{{ offerName }}</strong>
                            </div>
                        </div>
                        <div class='row divider'>
                            <div class='col-12'>
                                <h3>Store #</h3>
                            </div>
                        </div>
                        <div class='row value'>
                            <div class='col-12 mb-1'>
                                <strong>{{ firstOrder.door }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="offerError != ''" class="row error-msg" :class="{'success': pickSuccess}">
                    <div class="col-12 text-center">
                        <span>{{offerError}}</span>
                        <a class='multi-order-list' 
                            v-if='isItemInMultipleOrders' 
                            v-for="(item, index) in itemInMultipleOrdersList" 
                            :key='index'
                            :href="'https://wgaca--dev--rstk.visualforce.com//apex/SalesOrderWorkbench?div=aATf4000000GnHmGAK&ordno='+item.order_number" 
                            target="_blank"> 
                                {{item.order_number}}
                        </a>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-6 offset-6 mt-2">
                        <button type="button" class="btn btn-secondary btn-sm btn-clear-selected" @click.prevent="removeSku(currentProduct.productSku)">
                        Clear Selected
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-3">
            <label for="input-loa" class="form-label">
                Scan LOA
            </label>
            <input ref='loaInput' type="text" v-model="loaToPick" :disabled="loaDisabled" class="form-control" id="input-loa-to-pick" :placeHolder='productLoa' @focus='loaResponse=""' @keyup='setLoa'>
            <!-- <span v-if='getDuplicateLOA.duplicate > 0'>LOA duplicate? {{getDuplicateLOA}}</span> -->
            <span class='loaError text-center' :class="{'loa-success': loaPairValid}" v-if="loaResponse != ''">{{loaResponse}}</span>
        </div>
        <div class="row mb-3">
            <div class="col-6 offset-6 mt-2">
                <button type="button" class="btn btn-primary btn-sm" @click.prevent="linkLoa" :disabled="!LoaActive">
                    Link SKU + LOA
                </button>
            </div>
        </div>
       <!-- <div class="pt-3">
            <label for="input-loc-to-transfer" class="form-label">
                Scan Location
            </label>
            <!--<input ref='locInput' type="text" v-model="toLocation" :disabled="!orderToTransfer" class="form-control" id="input-loc-to-transfer" @keyup="setBin">
            <span :class="{'validated':destinationValid}" class='scannedBinError' v-if="scannedBinError != ''">{{scannedBinError}}</span> -->
            
           <!-- <LocationSearch 
                ref="locSearch"
                :items="searchLocations"
                :disabled="!orderToTransfer"
                name="locationSearchValue"
                store="PowerScan"
                :isAsync="true"
                id="input-loc-to-transfer"
                classes="form-control"
                reference="locInput"
                @get-locations="getLocations"
                @key-up="setBin"
            />
            <span :class="{'validated':destinationValid}" class='scannedBinError' v-if="scannedBinError != ''">{{scannedBinError}}</span>
        </div>
        <div class="row mb-3">
            <div class="col-6 offset-6 mt-2">
                <button v-if="resolveText == 'SAVE / TRANSFER'" type="button" :disabled="!destinationValid" class="btn btn-primary btn-sm" @click.prevent="transferItem">
                    {{resolveText}}
                </button>
                <button v-if="resolveText == 'PICK'" type="button" class="btn btn-primary btn-sm" @click.prevent="pickItem">
                    {{resolveText}}
                </button>
            </div>
        </div> -->
        <div class='row divider'>
            <div class='col-12'>
                <h3>LAST SCANNED</h3>
            </div>
        </div>
        <div v-if='lastSku' class="row mb-5">
            <div class="col-10 mb-5">
                <span>{{lastSku}}</span>
            </div>
            <div class="col-2 mb-5 mt-1">
                <a :href='seeMoreLink' target='_blank' >See More</a>
            </div>
        </div>
    </div>
</template>
<script>
import LocationSearch from './LocationSearch';
export default {
    name: 'Pbb',
    components:{
        LocationSearch
    },
    data() {
      return {
        skuToPick : '',
        customerName : '',
        soNumber : '',
        customerPoNumber : '',
        orderBinNum : '',
        scannedItems : [],
        sku : '',
        selectedSkus : [],
        scannedSkus : [],
        itemOfferData:{},
        offerError: '',
        offerStoreNum : '',
        orderId:'',
        orderLineId:'',
        orderNo: '',
        purchaseNo:'',
        enteredOrders: this.$store.getters['PowerScan/ordersInPick'] || [] ,
        toLocation:'',
        scannedBinError:'',
        destinationValid: false,
        toLocId: '',
        toLocNum: '',
        division: this.$store.getters['PowerScan/division'],
        offerName:'',
        loaResponse:'',
        loaPairValid: false,
        searchLocations: [],
        pickSuccess: false,
        itemToPick:{},
        isItemInMultipleOrders:false,
        itemInMultipleOrdersList:[],
        loaDisabled:true,
        duplicateLOA:[],
        getDuplicateLOA:{}
      }
    },
    mounted(){
        this.scannedItems = this.scannedCollection;
        this.$refs.skuInput.focus();
    },
    computed:{
        isLoaActive(){
            return this.LoaActive ? 'ON' : 'OFF';
        },
        productDescription(){
            return this.$store.getters['ItemInfo/description'] || ' ' 
        },
        productSku(){
            return this.$store.getters['ItemInfo/productSku'] || ' ' 
        },
        productImage(){
            return this.$store.getters['ItemInfo/productImageSrc'] || ' ' 
        },
        productLoa(){
            return this.$store.getters['ItemInfo/lOANumber'] || '' 
        },
        /*getDuplicateLOA(){
            return this.$store.getters['ItemInfo/duplicateLOA'] || '' 
        },*/
        scannedCollection(){
            return this.$store.getters['ProductCollection/scannedCollection']
        },
        currentProduct(){
            return this.$store.state.ItemInfo
        },
        scannedOrder(){
            return this.$store.getters['ItemCard/currentOffer']
        },
        resolveText(){
            return (Object.keys(this.scannedOrder).length > 0 && this.scannedOrder.orders.length > 0)  ? 'PICK' : 'SAVE / TRANSFER'
        },
        scanError(){
            return this.$store.getters['ItemCard/productFetchError'].toString()
        },
        firstOrder(){
            return this.scannedOrder.orders[0] || {}
        },
        productOfferError(){
            return this.$store.getters['ItemCard/productOfferError'].toString()
        },
        orderLink(){
            return 'https://wgaca--dev--rstk.visualforce.com//apex/SalesOrderWorkbench?div=aATf4000000GnHmGAK&ordno='+ this.firstOrder.order_number || '#'
        },
        selectedSite(){
            return this.$store.getters['PowerScan/selectedSite'];
        },
        currentSite(){
            return this.$store.getters['PowerScan/currentSite'];
        },
        seeMoreLink(){
            return 'https://wgaca.my.salesforce.com/apex/SKULookup?sku='+this.lastSku
        },
        LoaActive :{
            get(){
                return this.$store.getters['PowerScan/loaActive']
            },
            set(value){
                this.$store.dispatch('PowerScan/set', {field:'loaActive', value: value})
            }
        },
        ordersInPick:{
            get(){
                return this.$store.getters['ProductCollection/ordersToPick']
            },
            set(value){
                this.$store.dispatch('PowerScan/set', {field:'ordersInPick', value: value})
                this.$store.dispatch('ProductCollection/set', {field:'ordersToPick', value: value})
            }
        },
        locationSearchValue:{
            get(){
                return this.$store.getters['PowerScan/locationSearchValue']
            },
            set(value){
                this.$store.dispatch('PowerScan/set', {field:'locationSearchValue', value: value})
            }
        },
        lastSku:{
            get(){
                return this.$store.getters['PowerScan/lastSkuScanned']
            },
            set(value){
                this.$store.dispatch('PowerScan/set', {field:'lastSkuScanned', value: value})
            }
        },
        orderToTransfer(){
            return (Object.keys(this.scannedOrder).length > 0 && this.scannedOrder.orders.length > 0) ? false : true
        },
        loaToPick:{
            get(){
                return this.$store.getters['ItemInfo/lOANumber'] || '' 
            },
            set(value){
                this.$store.dispatch('ItemInfo/set', {field:'lOANumber', value: value})
            }
        } 
 
    },
    methods: {
      async getHistory(sku){
        let ItemHistory = await this.$store.dispatch('ItemCard/fetchItemHistory', sku);
        return ItemHistory;
      },
      removeSku(sku) {
        if(this.scannedItems.findIndex(x => x.sku == sku) != -1){
            this.scannedItems.splice(this.scannedItems.indexOf(sku), 1);
            this.$store.dispatch('ProductCollection/removeScannedItem', sku);
            /*this.$store.dispatch('Navigation/addPendingNotification',{
                icon: 'RemoveIcon',
                header: 'Remove From Scanned List',
                message: sku + ' - removed from Scanner list',
                type: 'success'
            }).then((response) => {
                //console.log('response to set notification - '+ response)
                setTimeout(() => { this.addFinalNotification(sku, '', response)}, 5000);
            });*/

        }
        this.currentProduct.productSku = null;
      },
      async pickItem(e){
           this.offerError = 'ITEM SENT FOR PICKING...'
           this.pickSuccess = false;
           let pickedItem = {
                name: 'PickItem',
                req_ref: Math.random().toFixed(10),
                product: this.itemToPick, 
                //bin: originBin,
                params: {
                    rstk__soprod_prod__c: this.lastSku,
                    rstk__sydata_sohdr__c: this.scannedOrder.orders[0].order_id,
                    rstk__sydata_txnqty__c: 1,
                    rstk__sydata_txntype__c: 'Sales Order Pick-Pack',
                    rstk__sydata_sydiv__r: this.division,
                    rstk__sydata_icitem__r: `${this.division}_${this.lastSku}`,
                    //rstk__sydata_docno__c: this.timestamp, //timestamp doesn't seem to work
                    rstk__sydata_soline__c: this.scannedOrder.orders[0].order_line_id
                }
            }
            let pickedItemSubmit = {
                name: pickedItem.name,
                req_ref: pickedItem.req_ref,
                params: pickedItem.params,
                product: pickedItem.product,
                api_token: 'token'
            }
            const response = await this.$store.dispatch('PowerScan/transferInventory', pickedItemSubmit)
                //.then((response) => {
                    let errorMsg = '';
                    //console.log('response - '+  JSON.stringify(response));
                    let itemID = response.params.rstk__soprod_prod__c ? response.params.rstk__soprod_prod__c : response.params.item
                    if(response.error == false){
                        this.pickSuccess = true;
                        this.offerError = 'ITEM '+ itemID +' SUCCESSFULLY PICKED! ref id: '+response.id;
                    }else{
                        //errorMsg = response.response.includes('Execution') ? 'PICK FAILED' : response.response;
                        this.offerError = 'PICK FAILED FOR '+ itemID + ',  ref id: '+response.id;
                    }
                //});
            //this.removeSku(this.currentProduct.productSku);

       },
       async setBin(e, loc){
          let enter = ( 'Enter' == e.key ? '' : '' )
          this.scannedBinError = '';
          this.destinationValid = false;
          this.toLocation = loc;
            if ( 'Enter' == e.key ) {
                this.scannedBinError = '';
                if(!this.locationSearchValue || this.locationSearchValue == ''){
                    this.scannedBinError = 'No Bin entered'
                }else{
                    if(this.locationSearchValue.indexOf('_') == -1){
                        this.scannedBinError = 'Invalid Bin Format'
                    }else{
                        let binCheck = await this.$store.dispatch('PowerScan/fetchLocationValidation', this.toLocation)
                        .then((response)=>{
                            if (response['valid']){
                                let splitBin = this.locationSearchValue.split('_');
                                this.toLocId = splitBin[0];
                                this.toLocNum = splitBin[1];
                                this.destinationValid = true;
                                this.scannedBinError = 'Bin Ready For Transfer'
                            }else{
                                this.scannedBinError = response['message'];
                            }
                        });
                    }
                }
            }
      },
      setLoa(e){
          let enter = ( 'Enter' == e.key ? '' : '' )
            if ( 'Enter' == e.key ) {
                this.linkLoa()
                .then(() =>{
                    //console.log("focus!!");
                    this.$refs.skuInput.focus();
                });
            }
      },
      async linkLoa(){
          this.getDuplicateLOA = '';
          let loaSku = this.sku == '' ? this.lastSku : this.sku; //lastSku is still the current sku - this is just a backup in case the input field is re-focused and loses the value - JM
          let isThereDup = false;
          this.getDuplicateLOA = await this.$store.dispatch('PowerScan/checkDuplicateLOA', {sku: loaSku, loa: this.loaToPick, img:this.itemToPick.img})
          if(this.getDuplicateLOA.duplicate == 0){

            let loaResults = await this.$store.dispatch('PowerScan/assignLOA', {sku: loaSku, loa: this.loaToPick, img:this.itemToPick.img})
                //console.log(' last sku is '+this.sku);
                this.$store.dispatch('PowerScan/logLOATransaction', {                    
                        name: 'LogTransaction',
                        req_ref: Math.random().toFixed(10),
                        api_token: 'token',
                        params:{
                            action: 'Set LOA',
                            sku: loaSku,
                            loa: this.loaToPick,
                            user: this.$store.getters['Auth/name']
                        }
                    }
                )
                //console.log('loa-paired - ', loaResults);
                this.loaResponse = loaResults ? 'Pairing Successful' : 'Pairing failed';
                this.loaPairValid = loaResults;
          }else{
              this.loaResponse = 'Pairing failed - LOA already in use';
              this.loaPairValid = false;
          }
      },
      transferItem(){
        let currentMissingSkus = this.missingSkus;
        let transferringProduct = {
            name: 'InventoryTransfer',
            req_ref: Math.random().toFixed(10),
            params: {
                item: this.lastSku,
                type: 'INVLOCLOC',
                quantity: 1,
                //from_div: this.division,
                to_div: this.division,
                //from_site: product.siteId,
                to_site: this.selectedSite.Id,
                //from_locid: `${this.division}_${this.currentSite}_${product.loc_id}`,
                to_locid: `${this.division}_${this.currentSite}_${this.toLocId}`,
                //from_proj: product.proj,
                //to_proj: product.proj,
                //from_locnum: product.loc_num,
                to_locnum: this.toLocNum
            },
            api_token: 'token'
        };
        const response = this.$store.dispatch('PowerScan/transferInventory', transferringProduct);
        this.removeSku(this.currentProduct.productSku)
      },

      findItem(e){
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
            e.preventDefault()
            this.$refs.skuInput.blur();
            this.pickSuccess = false;
            //console.log('Enter pressed - sku: ', this.sku);
            this.offerError = '';
            this.orderBinNum = '';
            this.customerName = '';
            this.offerStoreNum = '';
            this.toLocation = '';
            this.offerName = '';
            this.scannedBinError = '';
            this.destinationValid = false;
            this.lastSku = this.sku;
            this.orderId;
            this.orderLineId;
            let foundItem = this.$store.dispatch('ItemCard/fetchItem', {sku: this.sku, store: 'PowerScan'})
                .then((response) => {
                    let timeStamp = Date.now()
                    let tempProduct = {
                        sku : this.productSku,
                        description : this.productDescription,
                        img : this.productImage,
                        selected: false,
                        order_Id: '',
                        order_line_Id:'',
                        timeAdded: timeStamp
                    }
                    this.itemToPick = tempProduct;
                    if (this.LoaActive == true) this.loaDisabled = false;
                    //console.log("loa set? -"+ JSON.stringify(foundItem))
                    let fetchError = '';
                    let orderInfo = this.getOrderInfo()
                        .then(()=>{
                            tempProduct.order_Id = this.orderId;
                            tempProduct.order_line_Id = this.orderLineId;
                        
                            if(this.scanError == ''){
                                let tempProductCollection = this.scannedCollection;
                                if(tempProductCollection.findIndex(x => x.sku == tempProduct.sku) == -1){
                                    tempProductCollection.push(tempProduct);
                                    this.$store.dispatch('ProductCollection/set', {field: 'scannedCollection', value: tempProductCollection})
                                    
                                }else{
                                    fetchError = "Error: Product already Scanned"
                                }
                                if(this.LoaActive){
                                    this.$refs.loaInput.focus();
                                }
                            }
                        });
                    //this.getOrderInfo()
                    fetchError = (fetchError == '') ? this.scanError : fetchError;
                    //console.log("add pending Notification");
                    /*this.$store.dispatch('Navigation/addPendingNotification',{
                        icon: 'SearchIcon',
                        header: 'Item Search',
                        message: 'Search for: ' + this.sku,
                        type: (fetchError == '') ? 'success' : fetchError
                    }).then((response) => {
                        this.sku =''
                        this.$refs.loaInput.focus();
                        //console.log('response to set notification - '+ response)
                        setTimeout(() => { this.addFinalNotification(this.sku, fetchError, response)}, 5000);
                    });*/
                });
            }
        },
        async getOrderInfo(){
            this.isItemInMultipleOrders = false;
            this.itemInMultipleOrdersList = [];
            let offerData = await this.getItemData(this.sku)
                .then((response) => {
                    //console.log('offer response: ', response);
                    if ( response.offer == null || response.offer == ''){
                        this.offerError = 'Offer not found - put away item';
                        //this.$refs.locSearch.$refs.locInput.focus();
                        this.$refs.skuInput.focus();
                    }else if (response.orders.length > 1){
                        let orderstring = 'Item Found in Multiple orders: '
                        this.isItemInMultipleOrders = true;
                        response.orders.forEach((order) => {
                            this.itemInMultipleOrdersList.push(order);
                            //orderstring += "<a href='https://wgaca--dev--rstk.visualforce.com//apex/SalesOrderWorkbench?div=aATf4000000GnHmGAK&ordno='" + order.order_number+">"+order.order_number+"</a> "
                        })
                        this.offerError = orderstring;
                    }else{
                        this.customerName = response.customer;
                        this.offerName = response.po_number;
                        this.orderBinNum = response.bin;
                        this.offerStoreNum = response.site;
                        this.offerName = response.offer;
                        if(response.orders.length == 1){

                        
                            this.itemOfferData = response.orders[0];
                            let orderedQty = response.orders[0].qty_ordered;
                            let pickedQty = response.orders[0].qty_picked;
                            this.purchaseNo = response.orders[0].po_number;

                            if(orderedQty - pickedQty <= 0){
                                this.offerError = 'Item already picked'
                            }  else {
	                            //console.log('picking twice?')
	                            //this.pickItem();
                            
                                this.orderId = response.orders[0].order_id;
                                this.orderLineId = response.orders[0].order_line_id;
                                this.orderNo = null || response.orders[0].order_number;
                                let selectionOrder = {
                                    name: this.orderNo,
                                    Id: this.orderId,
                                    lineId: this.orderLineId,
                                    purchaseNo: this.purchaseNo
                                }
                                if(this.enteredOrders.findIndex(x => x.name == selectionOrder.name) == -1){
                                    //console.log("the order shouldn't be here");
                                    this.enteredOrders.push(selectionOrder);
                                    this.ordersInPick = this.enteredOrders;
                                }
                                if(this.offerError == ''){
                                    //console.log('Picking item');
                                    this.pickItem(null);
                                }
                            }
                        }else{
                            this.offerError = 'Item on offer: '+ this.offerName + ' But is not on an order yet.'
                        }
                        if(this.LoaActive){
                            this.$refs.loaInput.focus();
                        }else{
                            this.$refs.skuInput.focus();
                        }
                        
                    }
                    
                })
                .catch((error) => {
                    console.log('error - ', error)
                    this.offerError = (error == 'Request Failed with status 404') ?  'No Offer Found - Put Away Item' : error;
                    this.getHistory(this.lastSku)
                    .then((response) =>{
                        //console.log('post-response', response[response.length - 1].type);
                        if(response[response.length - 1].type == 'Sale'){
                            this.offerError = `Item sold to  ${response[response.length - 1].to}`
                        }
                        //this.item.currentLoc = response[response.length-1].to;
                        //this.addFinalNotification(item.sku, fetchError, myNotification);
                    })
                    .catch((error) => {
                        console.log('error: ',error);
                    });
                    //this.$refs.locSearch.$refs.locInput.focus();
                    this.$refs.skuInput.focus();

                })
        },
        addFinalNotification(value, fetchError, pendingNotification){
            //console.log("add final notification");
            this.$store.dispatch('Navigation/addNotification',{
                icon: pendingNotification.icon,
                header: pendingNotification.header,
                message: pendingNotification.message,
                type: pendingNotification.type
            });
            this.$store.dispatch('Navigation/removePendingNotification', pendingNotification);
        },
        async getItemData(sku){
            let ItemData = await this.$store.dispatch('ItemCard/fetchOfferInventoryData', sku)
                return ItemData;
            
        },
        async getLocations(search){
            let locationsFromSearch = await this.$store.dispatch('PowerScan/fetchCurrentLocations', search);
            this.searchLocations = locationsFromSearch;
        },
        
    },
    watch: {
            isLoaActive: function (val) {
                this.$refs.skuInput.focus();
            }
        }
}
</script>
